(function () {
  if (window.__fbpSearchInsightsLoaded) return;
  window.__fbpSearchInsightsLoaded = true;

  // The script is now served by Shopify; analytics still uses the existing service.
  var LOG_URL = 'https://chat.furrybodypillows.com/search-insights/log';

  var SESSION_KEY = 'fbp_search_insights_browser_session_v1';
  var PENDING_KEY = 'fbp_search_insights_pending_submit_v1';
  var MAX_QUERY_LENGTH = 160;
  var bindTimer = 0;
  var fallbackSessionId = '';
  var inputState = new WeakMap();
  var lastResultsSignature = '';

  function nowIso() {
    return new Date().toISOString();
  }

  function normalizeQuery(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, MAX_QUERY_LENGTH);
  }

  function normalizePath(value) {
    var text = String(value || '').trim();
    if (!text) return '';
    try {
      var parsed = new URL(text, window.location.origin);
      return parsed.origin === window.location.origin
        ? parsed.pathname + parsed.search + parsed.hash
        : parsed.href;
    } catch {
      return text.slice(0, 500);
    }
  }

  function currentPath() {
    return window.location.pathname + window.location.search + window.location.hash;
  }

  function makeId(prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return prefix + '_' + window.crypto.randomUUID().replace(/-/g, '');
    }
    return prefix + '_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function ensureBrowserSessionId() {
    try {
      var existing = window.localStorage.getItem(SESSION_KEY);
      if (existing) return existing;
      var created = makeId('browser');
      window.localStorage.setItem(SESSION_KEY, created);
      return created;
    } catch {
      if (!fallbackSessionId) fallbackSessionId = makeId('browser');
      return fallbackSessionId;
    }
  }

  function readPendingSubmit() {
    try {
      var raw = window.sessionStorage.getItem(PENDING_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  function savePendingSubmit(payload) {
    try {
      window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(payload));
    } catch {}
  }

  function clearPendingSubmit() {
    try {
      window.sessionStorage.removeItem(PENDING_KEY);
    } catch {}
  }

  function localeValue() {
    return String(window.navigator.language || '').trim();
  }

  function timezoneValue() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch {
      return '';
    }
  }

  function transmit(payload, preferBeacon) {
    var body = JSON.stringify(payload);
    if (preferBeacon && navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon(LOG_URL, blob)) {
          return Promise.resolve(true);
        }
      } catch {}
    }

    return fetch(LOG_URL, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      keepalive: Boolean(preferBeacon),
      headers: {
        'content-type': 'application/json'
      },
      body: body
    }).catch(function () {
      return null;
    });
  }

  function buildPayload(query) {
    return {
      query_text: query,
      source_page: currentPath(),
      browser_session_id: ensureBrowserSessionId(),
      locale: localeValue(),
      timezone: timezoneValue(),
      client_logged_at: nowIso()
    };
  }

  function newSearchRoot(scope) {
    if (!scope || typeof scope.closest !== 'function') return null;
    return scope.closest('[data-fbp-search]');
  }

  function fullQuery(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function readyCounts(root) {
    if (!root || root.dataset.fbpSearchReady !== 'true') return null;
    var input = root.querySelector('[data-fbp-search-input]');
    if (!input || fullQuery(input.value) !== fullQuery(root.dataset.fbpSearchQuery)) return null;
    var raw = root.dataset.fbpSearchTotal;
    if (typeof raw !== 'string' || !/^(0|[1-9]\d*)$/.test(raw)) return null;
    var count = Number(raw);
    if (!Number.isSafeInteger(count)) return null;
    return {
      predictive_total_results: count,
      predictive_product_results: count,
      predictive_suggestion_results: 0,
      predictive_no_results: count === 0 ? 1 : 0
    };
  }

  function collectPredictiveCounts(scope) {
    var newRoot = newSearchRoot(scope);
    if (newRoot) return readyCounts(newRoot);
    var root = null;
    if (scope && typeof scope.querySelector === 'function') {
      root = scope.querySelector('#search-ajax-results');
    }
    if (!root) {
      root = document.querySelector('#search-ajax-results');
    }

    var productCount = root ? root.querySelectorAll('li.grid-wrapper').length : 0;
    var suggestionCount = root ? root.querySelectorAll('.suggestions-list li.list-item').length : 0;
    var pageCount = root ? root.querySelectorAll('.pages-list li.list-item').length : 0;
    var liveRegion = scope && typeof scope.querySelector === 'function'
      ? scope.querySelector('[data-search-ajax-live-region-count-value]')
      : document.querySelector('[data-search-ajax-live-region-count-value]');
    var summaryText = liveRegion ? String(liveRegion.textContent || '').trim() : '';
    var total = productCount + suggestionCount + pageCount;
    var noResults = total === 0 && /no results/i.test(summaryText);

    return {
      predictive_total_results: total,
      predictive_product_results: productCount,
      predictive_suggestion_results: suggestionCount + pageCount,
      predictive_no_results: noResults ? 1 : 0
    };
  }

  function searchAjaxForInput(input) {
    if (!input) return null;
    return newSearchRoot(input) || input.closest('search-ajax') || input.closest('.search-form') || null;
  }

  function stateForInput(input) {
    if (!inputState.has(input)) {
      inputState.set(input, {
        captureTimer: 0,
        captureToken: 0,
        lastPredictiveSignature: '',
        composing: false,
        hasTyped: false
      });
    }
    return inputState.get(input);
  }

  function schedulePredictiveCapture(input) {
    var query = normalizeQuery(input && input.value);
    if (query.length < 2) return;
    var state = stateForInput(input);
    if (state.composing) return;
    state.captureToken += 1;
    window.clearTimeout(state.captureTimer);
    var token = state.captureToken;
    state.captureTimer = window.setTimeout(function () {
      attemptPredictiveCapture(input, token, 0);
    }, 650);
  }

  function attemptPredictiveCapture(input, token, attempt) {
    var state = stateForInput(input);
    if (token !== state.captureToken || state.composing) return;
    var query = normalizeQuery(input && input.value);
    if (query.length < 2) return;

    var scope = searchAjaxForInput(input);
    if (scope && scope.hasAttribute && scope.hasAttribute('loading') && attempt < 8) {
      window.setTimeout(function () {
        attemptPredictiveCapture(input, token, attempt + 1);
      }, 220);
      return;
    }

    var counts = collectPredictiveCounts(scope);
    if (!counts) return;
    var signature = [query, counts.predictive_total_results, counts.predictive_product_results, counts.predictive_no_results].join('|');
    if (signature === state.lastPredictiveSignature) return;
    state.lastPredictiveSignature = signature;

    transmit(Object.assign(buildPayload(query), {
      event_id: makeId('search'),
      flow_id: '',
      event_kind: 'typed',
      metadata: {
        ui: scope && scope.tagName ? String(scope.tagName).toLowerCase() : 'search'
      }
    }, counts), false);
  }

  function inputFromForm(form) {
    return form.querySelector('input[name="q"], input[type="search"]');
  }

  function buildSearchUrl(form, query) {
    try {
      var url = new URL(form.getAttribute('action') || '/search', window.location.origin);
      var formData = new FormData(form);
      formData.set('q', query);
      formData.forEach(function (value, key) {
        if (value == null || value === '') return;
        url.searchParams.set(key, String(value));
      });
      return normalizePath(url.toString());
    } catch {
      return '/search?q=' + encodeURIComponent(query);
    }
  }

  function bindSearchInput(input) {
    if (!input || input.dataset.fbpSearchInsightsBound === 'true') return;
    input.dataset.fbpSearchInsightsBound = 'true';
    input.addEventListener('compositionstart', function () { stateForInput(input).composing = true; });
    input.addEventListener('compositionend', function () { var state = stateForInput(input); state.composing = false; state.hasTyped = true; schedulePredictiveCapture(input); });
    ['input', 'keyup', 'change'].forEach(function (eventName) {
      input.addEventListener(eventName, function () {
        stateForInput(input).hasTyped = true;
        if (!stateForInput(input).composing) schedulePredictiveCapture(input);
      });
    });
  }

  function bindSearchForm(form) {
    if (!form || form.dataset.fbpSearchInsightsFormBound === 'true') return;
    form.dataset.fbpSearchInsightsFormBound = 'true';
    var input = inputFromForm(form);
    if (!input) return;
    bindSearchInput(input);
    var newRoot = newSearchRoot(form);
    form.addEventListener('submit', function (event) {
      if (event.defaultPrevented || stateForInput(input).composing) return;
      var query = normalizeQuery(input.value);
      if (!query) return;
      if (newRoot && newRoot.dataset.mode === 'page') lastResultsSignature = '';
      var eventId = makeId('search');
      var searchUrl = buildSearchUrl(form, query);
      savePendingSubmit({
        event_id: eventId,
        query: query,
        search_url: searchUrl,
        source_page: currentPath(),
        saved_at: Date.now()
      });
      transmit(Object.assign(buildPayload(query), {
        event_id: eventId,
        flow_id: eventId,
        event_kind: 'submit',
        search_url: searchUrl,
        metadata: {
          action: normalizePath(form.getAttribute('action') || '/search')
        }
      }), true);
    }, Boolean(newRoot));
  }

  function bindSearchSurfaces() {
    document.querySelectorAll('form[action*="/search"]').forEach(bindSearchForm);
  }

  function queueBindSearchSurfaces() {
    window.clearTimeout(bindTimer);
    bindTimer = window.setTimeout(bindSearchSurfaces, 80);
  }

  function collectFinalResultsCount() {
    var newRoot = document.querySelector('[data-fbp-search][data-mode="page"]');
    if (newRoot) {
      var query = new URLSearchParams(window.location.search).get('q') || '';
      if (fullQuery(query) !== fullQuery(newRoot.dataset.fbpSearchQuery)) return null;
      var counts = readyCounts(newRoot);
      return counts ? counts.predictive_total_results : null;
    }
    var selectors = [
      '.search-list .search-item',
      '.search-page .search-item',
      '.template-search .search-item'
    ];
    for (var index = 0; index < selectors.length; index += 1) {
      var count = document.querySelectorAll(selectors[index]).length;
      if (count > 0) return count;
    }
    var title = String(document.title || '');
    var match = title.match(/Search:\s*(\d+)\s+results found/i);
    if (match) return Number(match[1]);
    if (/no results/i.test(document.body ? document.body.textContent : '')) return 0;
    return null;
  }

  function logResultsPage() {
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?search\/?$/i.test(window.location.pathname)) return;
    var params = new URLSearchParams(window.location.search);
    var query = normalizeQuery(params.get('q'));
    if (!query) return;

    var resultsCount = collectFinalResultsCount();
    if (resultsCount == null) return;
    var signature = [currentPath(), query, resultsCount].join('|');
    if (signature === lastResultsSignature) return;
    lastResultsSignature = signature;

    var pending = readPendingSubmit();
    var ageMs = pending && pending.saved_at ? Date.now() - Number(pending.saved_at) : Number.POSITIVE_INFINITY;
    var eventId = pending && pending.query && pending.query.toLowerCase() === query.toLowerCase() && ageMs < (15 * 60 * 1000)
      ? pending.event_id
      : makeId('search');

    transmit(Object.assign(buildPayload(query), {
      event_id: eventId,
      flow_id: eventId,
      event_kind: 'results',
      search_url: currentPath(),
      final_results_count: resultsCount,
      final_zero_results: resultsCount === 0,
      metadata: {
        title: document.title || ''
      }
    }), false);

    if (pending && pending.event_id === eventId) {
      clearPendingSubmit();
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-fbp-search-results] a, #search-ajax-results a');
    if (!link) return;
    var form = newSearchRoot(link) || link.closest('search-ajax') || link.closest('.search-form');
    var counts = collectPredictiveCounts(form);
    if (!counts) return;
    var input = form && typeof form.querySelector === 'function'
      ? form.querySelector('input[name="q"], input[type="search"]')
      : document.querySelector('form[action*="/search"] input[name="q"], form[action*="/search"] input[type="search"]');
    if (newSearchRoot(link) && !normalizeQuery(input && input.value)) return;
    var query = normalizeQuery(input && input.value ? input.value : link.textContent);
    if (!query) return;
    transmit(Object.assign(buildPayload(query), {
      event_id: makeId('search'),
      flow_id: '',
      event_kind: 'predictive_click',
      selected_url: normalizePath(link.href || ''),
      metadata: {
        clicked_text: normalizeQuery(link.textContent || '')
      }
    }, counts), false);
  }, true);

  document.addEventListener('fbp:search-results', function (event) {
    var root = newSearchRoot(event.target);
    if (!root || !readyCounts(root)) return;
    var input = root.querySelector('[data-fbp-search-input]');
    bindSearchSurfaces();
    var state = inputState.get(input);
    if (state && state.hasTyped) schedulePredictiveCapture(input);
    if (root.dataset.mode === 'page') logResultsPage();
  });

  window.addEventListener('popstate', function () {
    // The UI's synchronous or later result event is authoritative; this is
    // also useful for the unchanged native fallback page.
    window.setTimeout(logResultsPage, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindSearchSurfaces();
      window.setTimeout(logResultsPage, 320);
    }, { once: true });
  } else {
    bindSearchSurfaces();
    window.setTimeout(logResultsPage, 320);
  }

  new MutationObserver(queueBindSearchSurfaces).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.addEventListener('pageshow', function (event) {
    if (!event || event.persisted !== true) return;
    lastResultsSignature = '';
    queueBindSearchSurfaces();
    window.setTimeout(logResultsPage, 240);
  });
})();
